export enum BuyFeatureStates {
    BASIC = 'BASIC',
    FEATURE = 'FEATURE',
    WAITING = 'WAITING',
    HIDDEN = 'HIDDEN'
}